import { render } from "./CommentOrders.vue?vue&type=template&id=18f1b081&scoped=true"
import script from "./CommentOrders.vue?vue&type=script&lang=js"
export * from "./CommentOrders.vue?vue&type=script&lang=js"

import "./CommentOrders.vue?vue&type=style&index=0&id=18f1b081&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18f1b081"]])

export default __exports__